import React, { Fragment } from "react";
import { Box, Typography } from "@mui/material";

type props = {
  title?: React.ReactNode;
  sx?: object;
};

const ContentTextTitle: React.FC<props> = ({ title, sx }) => {
  return (
    <Box sx={{ pb: 4, textAlign: "center" }}>
      <Typography variant="subtitle1" sx={{ ...sx, whiteSpace: "pre-wrap" }}>
        {title}
      </Typography>
    </Box>
  );
};

ContentTextTitle.defaultProps = {
  title: (
    <Fragment>
      Ticketmelon Thailand <br /> Wristband Pre-registration
    </Fragment>
  ),
};

export default ContentTextTitle;
